import { jsx as _jsx } from "react/jsx-runtime";
import { Children, cloneElement, forwardRef, isValidElement, useCallback, useContext, useEffect, useImperativeHandle, useMemo, useRef } from 'react';
import { Context } from './Context';
import { DISPLAY_NAME_OPTIONS } from './constants';
const Options = forwardRef(({ as: Element = 'ul', children, ...rest }, forwardedRef) => {
    const { id, isOpen, activeOptionIndex, selectActiveOption, setIsOpen, setIsNavigatingWithKeyboard, selectedValue } = useContext(Context);
    const internalRef = useRef(null);
    useImperativeHandle(forwardedRef, () => ({
        scrollToActiveOption: () => {
            if (internalRef.current && activeOptionIndex >= 0) {
                const activeOption = internalRef.current.children[activeOptionIndex];
                if (activeOption) {
                    activeOption.scrollIntoView({ block: 'nearest' });
                }
            }
        }
    }), [activeOptionIndex]);
    useEffect(() => {
        if (internalRef.current && activeOptionIndex >= 0) {
            const activeOption = internalRef.current.children[activeOptionIndex];
            if (activeOption) {
                activeOption.scrollIntoView({ block: 'nearest' });
            }
        }
    }, [activeOptionIndex]);
    const handleClick = useCallback(() => {
        selectActiveOption();
        setIsOpen(false);
    }, [selectActiveOption, setIsOpen]);
    const handleMouseMove = useCallback(() => {
        setIsNavigatingWithKeyboard(false);
    }, [setIsNavigatingWithKeyboard]);
    const renderedChildren = useMemo(() => {
        if (!isOpen)
            return null;
        return Children.map(children, (child, index) => {
            var _a;
            if (isValidElement(child)) {
                const isActive = activeOptionIndex === index;
                const isSelected = (selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.id) === child.props.value.id;
                return cloneElement(child, {
                    index,
                    isActive,
                    isSelected,
                    key: (_a = child.key) !== null && _a !== void 0 ? _a : child.props.value.id
                });
            }
            return child;
        });
    }, [children, isOpen, activeOptionIndex, selectedValue]);
    return (_jsx(Element, { ...rest, "aria-labelledby": `${id}-label`, "data-testid": `${id}-options`, id: `${id}-options`, ref: internalRef, role: "listbox", onClick: handleClick, onMouseMove: handleMouseMove, children: renderedChildren }));
});
Options.displayName = DISPLAY_NAME_OPTIONS;
export { Options };
//# sourceMappingURL=Options.js.map